/** @format */

import React from 'react';
import { useStoreActions } from 'easy-peasy';

function ResetState(props) {
	const travelsSelectService = useStoreActions((actions) => actions.travelsSelect);
	const travelsSearchService = useStoreActions((actions) => actions.travelSearch);
	const cartService = useStoreActions((actions) => actions.cart);
	const contactService = useStoreActions((actions) => actions.contact);
	const paymentService = useStoreActions((actions) => actions.payment);
	const resultService = useStoreActions((actions) => actions.result);

	const resetState = () => {
		travelsSelectService.reset();
		travelsSearchService.reset();
		cartService.reset();
		contactService.reset();
		paymentService.reset();
		resultService.reset();
	};

	return <div onClick={() => resetState()}>{props.children}</div>;
}

export default ResetState;
